import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Users from '../components/Users.vue'
import Positions from '../components/Positions.vue'
import Editor from '../components/ResearchEditor.vue'
import Researches from '../components/Researches.vue'
import CustomColumns from '../components/CustomColumns.vue'
import ClosedPositions from '../components/ClosedPositions.vue'
import Dashboard from '../components/Dashboard.vue'
import UpdatePassword from '../views/UpdatePassword.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: ClosedPositions
  },
  {
    path: '/update-password',
    component: UpdatePassword
  },
  {
    path: '/dashboard',
    component: Dashboard
  },
  {
    path: '/users',
    component: Users
  },
  {
    path: '/columns',
    component: CustomColumns
  },
  {
    path: '/positions',
    component: Positions
  },
  {
    path: '/closedpositions',
    component: ClosedPositions
  },
  {
    path: '/editor',
    component: Editor
  },
  {
    path: '/researches',
    component: Researches
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
